const routes = {
    getNodes:'/artboards/nodes',
    getEdges:'/artboards/edges',
    updateNode:'/artboards/nodes/update',
    updateEdge:"/artboards/edges/update",
    CreateEdge:'/artboards/edges/add',
    CreateNode:'/artboards/nodes/add',
    DeleteNode:'/artboards/nodes/delete',
    DeleteEdge:'/artboards/edges/delete'

  };
  
  export default routes